import { render, staticRenderFns } from "./close-dialog.vue?vue&type=template&id=6c48978f&scoped=true"
import script from "./close-dialog.vue?vue&type=script&lang=js"
export * from "./close-dialog.vue?vue&type=script&lang=js"
import style0 from "./close-dialog.vue?vue&type=style&index=0&id=6c48978f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c48978f",
  null
  
)

export default component.exports